import React from 'react'
import { Text } from 'components'
import styles from './AsteriskExplain.module.scss'

const AsteriskExplain = ({
  show = false,
  callToActionConsiderations,
  strongStyle = false,
}) => {
  return (
    show && (
      <div className={styles.AsteriskExplain}>
        {callToActionConsiderations.map(consideration => (
          <Text
            key={consideration}
            bold={strongStyle}
            fontSize={strongStyle ? 'small' : 'xsmall'}
          >
            {consideration}
          </Text>
        ))}
      </div>
    )
  )
}

export default React.memo(AsteriskExplain)
